var util = require('./util');

var opt = module.exports =  {
    /**
     * @type {string}
     * @desc 接口版本'
     */
    v: '2.0.1',

    /**
     * @type {string}
     * @desc 上报接口
     */
    furl: util.getParameter('debug') ? '//etl-xlmc-ssl.xunlei.com/api/stat/rt/js' : '//etl-xlmc-ssl.xunlei.com/api/stat/rt/js',

    /**
     * @type {number}
     * @desc 应用标识
     */
    appid: null,

    /**
     * @type {string}
     * @desc md5密钥
     */
    s: null,

    /**
     * @type {object}
     * @desc 上报公共字段
     * @property {number} ai - appid         - 站点id
     * @property {string} dm - domain        - 域名
     * @property {string} ul - url           - 链接
     * @property {string} tt - title         - 页面标题
     * @property {string} sn - screen        - 屏幕尺寸
     * @property {string} cd - colordepth    - 颜色深度
     * @property {string} rr - referrer      - 页面来源
     * @property {string} rf - referfrom     - 页面来源
     * @property {string} ua - httpuseragent - 用户代理
     * @property {string} lg - language      - 页面语言
     * @property {string} ci - cookieid      - 访客标识
     */
    comm: {
        ai: null,
        dm: window.realdomain || document.domain,
        ul: document.URL,
        tt: document.title,
        sn: window.screen.width + 'x' + window.screen.height,
        cd: window.screen.colorDepth,
        rr: document.referrer,
        rf: util.getReferfrom() || '',
        ua: navigator.userAgent,
        lg: navigator.language,
        ci: util.getCookieId(),
        ed: {}
    },

    /**
     * @type {object}
     * @desc pv上报字段
     * @property {string} ii - interid - 上报类型 <pv | event | pageview | tp>
     * @property {number} tm - time    - 上报时间
     */
    // pv: {
    //     ii: null,
    //     tm: null,
    //     pu: null
    // },

    /**
     * @type {object}
     * @desc event上报字段
     * @property {string} ii - interid  - 上报类型 <pv | event | pageview | tp>
     * @property {number} tm - time     - 上报时间
     * @property {string} cg - category - 目标分类
     * @property {string} at - action   - 动作类型
     * @property {string} ed - extdata  - 自定义上报内容
     */
    // event: {
    //     ii: null,
    //     tm: null,
    //     cg: null,
    //     at: null,
    //     ed: null
    // },

    /**
     * @type {object}
     * @desc tp上报字段
     * @property {string} ii - interid  - 上报类型 <pv | event | pageview | tp>
     * @property {number} tm - time     - 上报时间
     * @property {number} tp - timepage - 页面访问时长
     */
    // tp: {
    //     ii: null,
    //     tm: null,
    //     tp: null
    // },

    /**
     * @func extend
     * @desc 拓展opt的公共字段
     * @returns {object} 拓展后的opt公共字段
     */
    extend: function (param) {
        opt.comm.ed = util.deepExtend({}, opt.comm.ed, param);
        return opt.comm;
    },

    /**
     * @func config
     * @desc 配置appid和secret
     */
    config: function (appid, secret, event, force) {
        this.appid = appid;
        this.comm.ai = appid;
        this.s = secret;
        if (typeof force === 'boolean') {
            this.force = force;
        }

        if (event) {
            this.event = util.unique(this.event.concat(event));
        }
    },

    /**
     * @type {array}
     * @desc 监听事件
     */
    event: ['click'],

    /**
     * @type {boolean}
     * @desc 调试模式
     */
    debug: util.getParameter('debug'),

    /**
     * @type {boolean}
     * @desc 强制上报
     */
    force: true
};


//////////////////
// WEBPACK FOOTER
// ./src/opt.js
// module id = 1
// module chunks = 0